export const GOOGLE_DRIVE_CDN = 'https://lh3.googleusercontent.com/d/';

export const HOURS = [
    "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30",
    "05:00", "05:30", "06:00", "06:30", "07:00", "07:30", "08:00", "08:30",
    "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00"
];
export const PERIOD = ['am', 'pm'];